<template>
	<div class="flex flex-col items-end">
		<div class="flex items-center">
			<div v-for="(star, index) in rating?.score" :key="index">
				<StarIcon class="h-4 w-4 text-secondary" alt="favorite product" />
			</div>

			<StarIcon
				v-for="(star, index) in printGrayStars"
				:key="index"
				class="h-4 w-4 text-gray-dark"
				alt="favorite product"
			/>
			<span v-if="rating?.votes" class="text-xs self-center">
				({{ rating.votes }})
			</span>
		</div>
		<NuxtLink
			v-if="readReviews"
			to="#"
			class="transition-all text-base underline"
			>Read reviews
		</NuxtLink>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { StarIcon } from "@heroicons/vue/24/solid";

interface Props {
	rating: { score: number; votes: number };
	readReviews?: boolean;
}

const { rating, readReviews } = defineProps<Props>();

const printGrayStars = computed(() => {
	const maximNumberOfStarts = 5;
	const score = rating?.score ?? 0;
	return maximNumberOfStarts - score;
});
</script>
